<template>
    <button @click="subscribe"><slot/></button>
</template>

<script>
import Swal from '../../helpers/swal' // lazy sweetalert2 (HAP-4635)
import { subscribeToMailChimp } from "../../helpers/email"
import { fireLeadConversion, fireFormError } from "../../helpers/leadConversion.js"

export default {
    props: {
        email: {type: String},
        source: {type: String},
        list: {type: String},
        // Distinguishes this placement in lead reporting. Defaults to the nav subscribe box,
        // which is the only live instance today (HAP-3876).
        formName: {type: String, default: 'global_nav_newsletter'},
    },
    methods: {
        async subscribe() {
            let {email, source, list, formName} = this
            // Previously the success alert fired even for an address the helper had just
            // rejected, so the visitor saw "Invalid Email" and "Subscribed!" back to back.
            const submitted = await subscribeToMailChimp({email, source, list})
            if (!submitted) return fireFormError({formName})

            fireLeadConversion({formName})
            Swal.fire('Subscribed!', 'Thank you for subscribing, we\'ll be in touch! 😉', 'success')
        }
    }
}
</script>
